import { KeyConstructor } from './keyConstructor';
const EMBED_KEY = 'embed';
const MEDIA_KEY = 'media';
export const getEmbedKey = KeyConstructor(EMBED_KEY);
export const getMediaKey = KeyConstructor(MEDIA_KEY);
//# sourceMappingURL=media.key.js.map